import { Directive, HostListener } from '@angular/core';

import { DrawerContainerComponent } from '../components/drawer-container/drawer-container.component';

@Directive({ standalone: true, selector: '[rtDrawerTrigger]' })
export class DrawerTriggerDirective {
  constructor(private drawerContainer: DrawerContainerComponent) {}

  // eslint-disable-next-line ban/ban
  @HostListener('click')
  public onClick() {
    this.drawerContainer.toggle();
  }
}
